const updates = [
  { id: 1, date: '07-31', title: '《星际远征：黑暗宇宙》高清版今日上线香蕉视频', tag: '新片上线' },
  { id: 2, date: '07-30', title: '红桃视频悬疑剧场更新《真相迷宫》全集，评分9.2', tag: '剧集更新' },
  { id: 3, date: '07-29', title: '蜜桃视频暑期综艺特辑上线，多档热门综艺一次看够', tag: '专题上线' },
  { id: 4, date: '07-28', title: '播放器全面升级，1080P画质优化，解码速度提升40%', tag: '技术升级' },
  { id: 5, date: '07-27', title: '91视频经典港片修复计划启动，首批20部影片高清重制', tag: '经典修复' },
  { id: 6, date: '07-26', title: '香蕉视频独家引进多部海外高分纪录片，中文字幕精校', tag: '独家引进' },
  { id: 7, date: '07-25', title: '番茄视频移动端APP更新至v3.2，支持画中画播放模式', tag: 'APP更新' },
  { id: 8, date: '07-24', title: 'CDN节点扩容完成，全国多地区播放速度显著提升', tag: '网络优化' },
  { id: 9, date: '07-23', title: '红桃视频古装剧场专题上线，热门古装剧一站式追完', tag: '专题上线' },
];

const tagColors: Record<string, string> = {
  '新片上线': 'bg-primary-100 text-primary-700',
  '剧集更新': 'bg-accent-100 text-accent-700',
  '专题上线': 'bg-secondary-100 text-secondary-700',
  '技术升级': 'bg-primary-100 text-primary-700',
  '经典修复': 'bg-accent-100 text-accent-700',
  '独家引进': 'bg-secondary-100 text-secondary-700',
  'APP更新': 'bg-primary-100 text-primary-700',
  '网络优化': 'bg-accent-100 text-accent-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">最新动态</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">番茄视频最新片源上线、功能升级与平台动态</p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updates.map((item) => (
              <div key={item.id} className="relative flex items-start gap-5 pl-12">
                <div className="absolute left-[11px] top-1.5 w-[17px] h-[17px] rounded-full border-2 border-primary-500 bg-background-50 flex-shrink-0"></div>
                <div className="flex-1 min-w-0 bg-background-100 rounded-xl border border-background-200/60 p-4 hover:border-primary-200 transition-all cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs font-medium text-foreground-400">{item.date}</span>
                    <span className={`px-2 py-0.5 rounded-md text-xs font-medium ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'}`}>{item.tag}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}